import { IOpenTextLessonTutorialState } from '@/types/redux'
import { createDraftSafeSelector } from '@reduxjs/toolkit'

const selectOnboardingTutorial = (state: any) =>
  state.openTextLessonOnboardingTutorialSlice

const openTextLessonTutorialSelector = createDraftSafeSelector(
  selectOnboardingTutorial,
  (openTextLessonTutorial: IOpenTextLessonTutorialState) =>
    openTextLessonTutorial,
)

export default openTextLessonTutorialSelector
